export const captureAndLog = () => { };
